import React from "react";
import CardComponentContainer from "../cardContainers/CardComponentContainer";
import FormSimpleComponent from "./FormSimpleComponent2";
import { v4 as uuidv4 } from "uuid";

/**
 * FormContainer component renders a form with a specified number of fields per line.
 * It can optionally display default right legends and custom children components.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.title - The title of the form.
 * @param {boolean} props.showDefaultRightLegends - Flag to show default right legends.
 * @param {number} [props.numOfFieldsPerLine=4] - Number of fields to display per line.
 * @param {Array} [props.formFields=[]] - Array of form field objects to render.
 * @param {React.ReactNode} props.afterTitleComponent - Component to render after the title.
 * @param {React.ReactNode} props.children - Custom children components to render inside the form.
 * @returns {JSX.Element} The rendered FormContainer component.
 */
export default function FormContainer(props) {
    const {
        title,
        showDefaultRightLegends,
        rightComponent,
        numOfFieldsPerLine = 4,
        formFields = [],
        children,
        afterTitleComponent,
        middleComponent,
        defaultRightLegendsDisabled
    } = props;

    return (
        <div>
            <CardComponentContainer
                title={title}
                spacing="16px"
                afterTitleComponent={afterTitleComponent}
                rightComponent={
                    showDefaultRightLegends ? (
                        <FieldsRightLegends defaultRightLegendsDisabled={defaultRightLegendsDisabled} />
                    ) : undefined
                }
                middleComponent={middleComponent}>
                <div
                    className="FormFieldsContainer"
                    style={{
                        display: !children && "inline-grid",
                        width: "100%",
                        gap: !children && "16px",
                        gridTemplateColumns: !children && `repeat(${numOfFieldsPerLine}, 1fr)`
                    }}>
                    {children
                        ? children
                        : formFields?.map(field => (
                              <FormSimpleComponent key={uuidv4()} className={field?.className} {...field} />
                          ))}
                </div>
            </CardComponentContainer>
        </div>
    );
}

const FieldsRightLegends = ({ defaultRightLegendsDisabled }) => {
    const Frame186 = {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "4px",
        textTransform: "none"
    };

    const Rectangle7 = {
        width: "6px",
        height: "6px",
        borderRadius: "600px"
    };

    const legendTitle = {
        color: defaultRightLegendsDisabled ? "#4F5B6D" : "#7c868b",
        fontSize: "12px",
        fontFamily: "Roboto",
        fontWeight: 400,
        wordWrap: "break-word"
    };

    return (
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
            <div className="Frame186" style={Frame186}>
                <div
                    className="Rectangle7"
                    style={{ ...Rectangle7, background: defaultRightLegendsDisabled ? "#4F5B6D" : "#00AEEF" }}
                />
                <div className="legendTitle" style={legendTitle}>
                    recommended
                </div>
            </div>
            <div className="Frame186" style={Frame186}>
                <div
                    className="Rectangle7"
                    style={{ ...Rectangle7, background: defaultRightLegendsDisabled ? "#4F5B6D" : "#FF9900" }}
                />
                <div className="legendTitle" style={legendTitle}>
                    mandatory
                </div>
            </div>
            <div className="Frame186" style={Frame186}>
                <div className="Rectangle7" style={{ ...Rectangle7, background: "#4F5B6D" }} />
                <div className="legendTitle" style={legendTitle}>
                    locked
                </div>
            </div>
        </div>
    );
};
